import { DefaultService, RegistrationSchema } from "../generated";
import { useMutation } from "@tanstack/react-query";

export const useRegisterEmail = () => {
  return useMutation({
    mutationKey: ["registerEmail"],
    mutationFn: (data: RegistrationSchema) =>
      DefaultService.fakturUsersViewsRegisterEmail({ requestBody: data }),
  });
};
